{
  "title": "Submission Failed",
  "description": "How to diagnose a submission that won't go through when you click \"Submit\".",
  "headings": ["Symptom", "Common Causes", "How to Diagnose", "Expected Result", "Still Stuck?"],
  "symptom": "Clicking \"Submit\" doesn't complete, or the button itself can't be clicked.",
  "causes": [
    "A required field is incomplete",
    "The submission isn't marked \"Ready\" yet",
    "A file doesn't meet the file limits",
    "The deadline has passed",
    "The submission window has not opened yet, or the chosen category has been archived"
  ],
  "diagnosis": [
    { "title": "Step 1", "description": "Confirm the submission status is currently \"Ready\"." },
    {
      "title": "Step 2",
      "description": "Check for a required-field prompt (usually shown next to the incomplete field)."
    },
    {
      "title": "Step 3",
      "description": "Confirm your uploaded files meet the format and size limits."
    },
    {
      "title": "Step 4",
      "description": "Confirm the current time is still before the competition's submission deadline. The deadline is the date shown on the competition page and the submission page (the current round's submission deadline)."
    }
  ],
  "resolution": "Once these are fixed, \"Submit\" should work normally.",
  "stillStuck": [
    "Competition name",
    "Team ID",
    "When it happened",
    "The error message",
    "A screenshot"
  ],
  "doNotProvide": ["Your password", "A verification code", "A token"],
  "nextSteps": "Still stuck after checking these? Revisit \"Submit Your Final Work\" and walk through the full steps again."
}
